export enum N11OrderStatus {
  CREATED = 'Created',
  CANCELLED = 'Cancelled',
}

export const n11OrderStatusNameMap: Record<N11OrderStatus, string> = {
  [N11OrderStatus.CREATED]: 'Sipariş Oluşturuldu',
  [N11OrderStatus.CANCELLED]: 'İptal Edildi',
};

export const n11OrderStatusDescriptionMap: Record<N11OrderStatus, string> = {
  [N11OrderStatus.CREATED]: 'Stok düşüldü',
  [N11OrderStatus.CANCELLED]: 'Stok geri eklendi',
};
